/* global _gaq, ga, RB */

import 'babel-polyfill';
import { render } from 'react-dom';
import React from 'react';
import CareersPageSidebar from './components/CareersPageSidebar';
import FilterInformation from './components/FilterInformation';
import SortByFilter from './components/SortComponent';
import ListFooter from './components/ListFooter';

const SELECTORS = {
	CAREERS_PAGE_SIDEBAR: 'js-sidebar',
	CAREERS_FILTER_INFO_WRAPPER: 'js-cs-filter-info',
	COMPANY_BANNER_IMAGE: '.js-company-header',
	SHOW_OPENINGS_BUTTON: '.js-show-openings',
	SHOW_FILTERS_BUTTON: '.js-toggle-filter',
	CAREERS_PAGE_FILTER: '.js-filters',
	OPENINGS_LIST: '.js-openings-list',
	FOLLOW_COMPANY_FORM: '.js-follow-company-form',
	CAREERS_SORT_WRAPPER: 'js-sort-component',
	CAREER_PAGE_LIST_FOOTER: 'js-list-footer',
};

function openingListPage() {
	careersPage();
}

const ROUTES = {
	'/': openingListPage,
};

function initRouter() {
	const path = window.location.pathname;
	if (ROUTES[path]) ROUTES[path]();
}

(() => {
	// initBStooltip();
	updateAllDatetoDateAgoFormat();
	handleCompanyCoverImage();
	handleToggleFiltersPanelForMobile();
	handleFollowTheCompanyFormSubmit();

	initRouter();
})();

function careersPage() {
	if (document.getElementById(SELECTORS.CAREERS_PAGE_SIDEBAR)) {
		render(<CareersPageSidebar />, document.getElementById(SELECTORS.CAREERS_PAGE_SIDEBAR));
	}
	if (document.getElementById(SELECTORS.CAREERS_FILTER_INFO_WRAPPER)) {
		render(<FilterInformation />, document.getElementById(SELECTORS.CAREERS_FILTER_INFO_WRAPPER));
	}
	if (document.getElementById(SELECTORS.CAREERS_SORT_WRAPPER)) {
		render(<SortByFilter />, document.getElementById(SELECTORS.CAREERS_SORT_WRAPPER));
	}
	if (document.getElementById(SELECTORS.CAREER_PAGE_LIST_FOOTER)) {
		render(<ListFooter />, document.getElementById(SELECTORS.CAREER_PAGE_LIST_FOOTER));
	}
}

function getHumanizedDate(timestamp) {
	const date = new Date(Number(timestamp) * 1000);
	const today = new Date();
	const diffTime = Math.abs(date - today);
	const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
	const datesText = diffDays === 1 ? 'days' : 'days';
	return diffDays + ' ' + datesText + ' ' + 'left';
}

function updateAllDatetoDateAgoFormat() {
	const allDates = document.querySelectorAll('[data-time]');
	for (let i = 0; i < allDates.length; i++) {
		allDates[i].innerHTML = getHumanizedDate(allDates[i].dataset.time);
	}
}

function handleCompanyCoverImage() {
	const bgImage = window.innerWidth < 500 ? RB.banner_images.mobile : RB.banner_images.desktop;
	$(SELECTORS.COMPANY_BANNER_IMAGE).css({ 'background-image': 'url(' + bgImage + ')' });

	$(SELECTORS.SHOW_OPENINGS_BUTTON).on('click', function(e) {
		e.preventDefault();
		$('html, body').animate(
			{
				scrollTop: $('#content').offset().top,
			},
			400,
		);
	});
}

function handleToggleFiltersPanelForMobile() {
	const toggle_filter_btn = $(SELECTORS.SHOW_FILTERS_BUTTON);
	toggle_filter_btn.click(function() {
		$(SELECTORS.CAREERS_PAGE_FILTER).removeClass('hidden-xs');
		$(SELECTORS.OPENINGS_LIST).addClass('hidden-xs');
	});
}

// eslint-disable-next-line
function initBStooltip() {
	// For some reason the bootstrap was taking time to load, so I have include this logic in _base.html
	$(document).ready(function() {
		$('[data-toggle="tooltip"]').tooltip({
			delay: { show: 350, hide: 100 },
		});
	});
}

const successMessage =
	"<div class='alert alert-success alert-lg'>" +
	"<i class='glyphicon glyphicon-ok icon-cirlce icon-success'></i>" +
	'<p>Thanks! You will receive updates from us in your email</p>' +
	'</div>';

function handleFollowTheCompanyFormSubmit() {
	const $followForm = $(SELECTORS.FOLLOW_COMPANY_FORM);
	$followForm.on('submit', function(e) {
		const $form = $(this);
		const $formFollowError = $('.js-follow-company-error');
		const $followWrapper = $('.js-follow-company-wrapper');
		const $submitButton = $(this).find('[data-loading-text]');
		setButtonLoading($submitButton, true);

		$.ajax({
			url: $form.attr('action'),
			type: $form.attr('method'),
			data: $form.serialize(),
			dataType: 'json',
		})
			.done(function(data) {
				var resp_str;
				resp_str = successMessage;
				$followWrapper.html(resp_str);

				if (window._gaq) {
					_gaq.push(['_trackEvent', 'Follow', 'success', '{{client.client_name}}']);
					ga('send', 'event', {
						eventCategory: 'Follow',
						eventAction: 'success',
						eventLabel: '{{client.client_name}}',
					});
				}
			})
			.fail(function(data) {
				var error_dict = JSON.parse(data.responseText);
				var resp_str;
				if (error_dict.email) {
					resp_str = "<span class='text-danger'>" + error_dict.email[0] + '</span>';
				} else if (error_dict.client_id) {
					resp_str = "<span class='text-danger'>" + error_dict.client_id[0] + '</span>';
				}
				setButtonLoading($submitButton, false);
				$formFollowError.html(resp_str);
				$formFollowError.show();
			});
		e.preventDefault();
	});
}

function setButtonLoading($btn, isLoading) {
	if (isLoading) {
		$btn.addClass('disabled').prop('disabled', true);
		$btn.data('text', $btn.html);
		$btn.text($btn.data('loadingText'));
	} else {
		$btn.removeClass('disabled').prop('disabled', false);
		$btn.text($btn.data('text'));
	}
}
